/**
 * Constructs a fully compliant NPCI UPI Deep Link URI.
 * Enforces exact NPCI field formatting for seamless recognition across Google Pay, PhonePe, Paytm, BHIM, etc.
 * 
 * @param amount Payment amount in INR
 * @param note Transaction description / note
 */
export const buildUpiUri = (amount: number | string, note: string = 'Aapli Gaadi Rental'): string => {
    const numericAmount = typeof amount === 'number' ? amount : (parseFloat(amount) || 0);
    const formattedAmount = numericAmount > 0 ? numericAmount.toFixed(2) : '0';
    const cleanNote = encodeURIComponent(note || 'Aapli Gaadi Rental');
    
    return `upi://pay?pa=crewtechsolutions@upi&pn=Crewtech%20Solutions&tn=${cleanNote}&am=${formattedAmount}&cu=INR`;
};

/**
 * Generates dynamic QR code image URL for a given UPI URI
 */
export const buildQrCodeUrl = (upiUri: string, size: number = 250): string => {
    return `https://api.qrserver.com/v1/create-qr-code/?size=${size}x${size}&data=${encodeURIComponent(upiUri)}`;
};
